import settingsRoutes from 'views/EMR/Settings/routes';

export default [{
  name: 'Messages',
  href: 'messages',
}, {
  title: 'Settings',
  name: 'Settings',
  href: 'settings',
  subRoutes: settingsRoutes,
}, {
  name: 'Notifications',
  href: 'notifications',
}, {
  name: 'Profile',
  title: 'Profile',
  href: 'profile',
}];
